// custom dependencies
import slick from 'slick-carousel';

const deps = {
  slickCarousel: slick
};

export default deps;
